import React from "react";
import { motion } from "framer-motion";
import { pageVariants } from "../animations/pageTransitions"; // Import animation config
import "./Capabilities.css";
import pall from "../../practices_images/palliative.jpg"; // Ensure this path is correct
import CollapsibleSection from "./CollapsibleSection"; // adjust path if needed

const HospiceCare = () => {
  return (
  <motion.div
    variants={pageVariants}
    initial="initial"
    animate="animate"
    exit="exit"
  >
    <div className="cap-container">
    <h1>Hospice and Palliative Care Facilities</h1>

    <div className="cap-section">
        {/* Text Content */}
        <div className="text-content">
            {/* ✅ First 2 sections: normal (always visible) */}
            <h3>Supporting compassionate care with operational clarity</h3>
            <p>
              Hospice and palliative care facilities provide comfort focused care for patients with serious, chronic, or life limiting conditions. These organizations operate in emotionally complex environments where clinical teams must remain fully present for patients and families while meeting rigorous administrative, regulatory, and financial requirements.
            </p>
            <p>
              We partner with hospice and palliative care facilities to help them maintain operational stability and clarity so care teams can focus on what matters most.
            </p>

            <h3>The Operating Environment</h3>
            <p>
              Hospice and palliative care facilities operate under highly specific reimbursement models and documentation standards, particularly within Medicare and Medicaid programs. Care is often delivered across multiple settings, requiring coordination, consistency, and accurate record keeping.
            </p>
            <p>
              Administrative complexity, when not well managed, can divert time and attention away from patient centered care.
            </p>

            {/* ✅ Everything after: collapsible */}
            <CollapsibleSection title="Our Role">
              <p>
                We help hospice and palliative care facilities strengthen the operational and financial foundations that support compassionate care delivery.
              </p>
              <p>
                Our work focuses on reinforcing documentation and billing accuracy, supporting compliant reimbursement processes, improving financial visibility, and strengthening compliance and audit readiness. We also support technology and security practices that protect sensitive patient information and enable reliable communication across care teams.
              </p>
              <p>
                Our approach is thoughtful, disciplined, and aligned with the sensitive nature of hospice and palliative care.
              </p>
            </CollapsibleSection>

            <CollapsibleSection title="Enabling Stability and Focus">
              <p>
                Our goal is to help organizations operate with confidence and transparency.
              </p>
              <p>
                By reducing administrative burden and strengthening financial oversight, we support greater organizational stability, improved compliance, and smoother operations. This allows care teams to remain focused on patients and families without distraction.
              </p>
            </CollapsibleSection>

            <CollapsibleSection title="Looking Ahead">
              <p>
                As demand for hospice and palliative care continues to grow, strong operational foundations remain essential.
              </p>
              <p>
                We work with facilities to build the structure, discipline, and resilience required to support compassionate care over the long term.
              </p>
              <p>
                Let’s begin a conversation about how your organization can move forward with clarity and purpose.
              </p>
            </CollapsibleSection>
        </div>

        {/* Image Section */}
        <div className="image-container">
        {<img src={pall} alt="Hospice and Palliative Medicine" />}
        </div>
    </div>
    </div>

  </motion.div>
  );
};

export default HospiceCare;
